import { createAction, props } from '@ngrx/store'
import { MULTI_CART_DATA } from '@spartacus/cart/base/core'
import { CartModificationList, OrderEntry } from '@spartacus/cart/base/root'
import { StateUtils } from '@spartacus/core'
import { EbCartModificationResult } from '../../interface/eb-cart.interface'
import { EbOrderEntry } from '../../interface/eb-order-entry.interface'

export const EB_CART_ADD_ENTRY = '[Eb-cart-entry] Add Entry'
export const EB_CART_ADD_ENTRIES = '[Eb-cart-entry] Add Entries'
export const EB_CART_REMOVE_ENTRY = '[Eb-cart-entry] Remove Entry'
export const EB_CART_UPDATE_ENTRY = '[Eb-cart-entry] Update Entry'
export const EB_CART_ADD_ENTRY_SUCCESS = '[Eb-cart-entry] Add Entry Success'
export const EB_CART_ADD_ENTRIES_SUCCESS = '[Eb-cart-entry] Add Entries Success'
export const EB_CART_ADD_ENTRIES_FAIL = '[Eb-cart-entry] Add Entries Fail'

export class EbCartAddEntry extends StateUtils.EntityProcessesIncrementAction {
  readonly type = EB_CART_ADD_ENTRY

  constructor(
    public payload: {
      cartId: string
      userId: string
      productCode: string
      quantity: number
    }
  ) {
    super(MULTI_CART_DATA, payload.cartId)
  }
}

export class EbCartAddEntries extends StateUtils.EntityProcessesIncrementAction {
  readonly type = EB_CART_ADD_ENTRIES

  constructor(
    public payload: {
      cartId: string
      userId: string
      entries: EbOrderEntry[]
    }
  ) {
    super(MULTI_CART_DATA, payload.cartId)
  }
}

export class EbCartAddEntriesSuccess extends StateUtils.EntityProcessesDecrementAction {
  readonly type = EB_CART_ADD_ENTRIES_SUCCESS

  constructor(
    public payload: {
      cartId: string
      cartModification: CartModificationList
    }
  ) {
    super(MULTI_CART_DATA, payload.cartId)
  }
}

export class EbCartAddEntriesFail extends StateUtils.EntityProcessesDecrementAction {
  readonly type = EB_CART_ADD_ENTRIES_FAIL

  constructor(
    public payload: {
      cartId: string
      error: any
    }
  ) {
    super(MULTI_CART_DATA, payload.cartId)
  }
}

export class EbCartRemoveEntry extends StateUtils.EntityProcessesIncrementAction {
  readonly type = EB_CART_REMOVE_ENTRY

  constructor(public payload: { cartId: string; userId: string; entryNumber: string }) {
    super(MULTI_CART_DATA, payload.cartId)
  }
}

export class EbCartUpdateEntry extends StateUtils.EntityProcessesIncrementAction {
  readonly type = EB_CART_UPDATE_ENTRY

  constructor(
    public payload: {
      userId: string
      cartId: string
      entryNumber: string
      quantity: number
    }
  ) {
    super(MULTI_CART_DATA, payload.cartId)
  }
}

export class EbCartAddEntrySuccess extends StateUtils.EntityProcessesDecrementAction {
  readonly type = EB_CART_ADD_ENTRY_SUCCESS

  constructor(
    public payload: {
      userId: string
      cartId: string
      productCode: string
      quantity: number
      deliveryModeChanged?: boolean
      entry?: OrderEntry
      quantityAdded?: number
      statusCode?: string
      statusMessage?: string
    }
  ) {
    super(MULTI_CART_DATA, payload.cartId)
  }
}

export const setCartModifications = createAction(
  '[EbCart] set cart modifications',
  props<EbCartModificationResult>()
)

export type EbCartEntryAction =
  | EbCartAddEntry
  | EbCartRemoveEntry
  | EbCartUpdateEntry
  | EbCartAddEntrySuccess
  | EbCartAddEntries
  | EbCartAddEntriesSuccess
